import React from 'react';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';

interface ResponsiveThemeProviderProps {
  children: React.ReactNode;
}

// Resetting to standard provider.
// No custom zoom logic.
export const ResponsiveThemeProvider: React.FC<ResponsiveThemeProviderProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles styles={{
        'html, body': { height: '100%', margin: 0 }
      }} />
      {children}
    </ThemeProvider>
  );
};

export default ResponsiveThemeProvider;
